import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import TotalYear from '../../states-year/Schools/TotalYear';
import TotalAssociatedWithProject from '../../states-year/Schools/TotalAssociatedWithProject';
import TotalAssociatedWithEvent from '../../states-year/Schools/TotalAssociatedWithEvent';
import TotalAssociatedWithProjectOrEvent from '../../states-year/Schools/TotalAssociatedWithProjectOrEvent';
import SchoolGrowthByMonth from '../../states-year/Schools/SchoolGrowthByMonth';
import CompositeSchoolGrowth from '../../states-year/Schools/CompositeSchoolGrowth';

export default function Schools(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics title="Schools">
        {/*<Total {...params} />*/}
        <TotalYear {...params} titleOnly={true} />
        <TotalAssociatedWithProject {...params} titleOnly={true} />
        <TotalAssociatedWithEvent {...params} titleOnly={true} />
        <TotalAssociatedWithProjectOrEvent {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="Growth"
        columns={1}
      >
        <SchoolGrowthByMonth {...params} />
        {/*<div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">*/}
        {/*  <CompositeSchoolGrowth {...params} titleOnly={true} />*/}
        {/*</div>*/}
      </LazyMetrics>
    </>
  );
}
